document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     ANIMATIONS AU SCROLL
     ============================================ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var animatables = document.querySelectorAll(
      '.section-head, .card, .cat-banner, .trust-grid > div, .split, .foot-grid, .facet'
    );
    animatables.forEach(function (el) {
      el.classList.add('reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animatables.forEach(function (el) { observer.observe(el); });

    var groups = document.querySelectorAll('[data-animate-group]');
    groups.forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
      });
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('reveal-in');
    });
  }

  /* ============================================
     PANNEAU DE FILTRES (mobile)
     ============================================ */
  var filtersToggle = document.querySelector('[data-filters-toggle]');
  var filtersClose = document.querySelector('[data-filters-close]');
  var filtersOverlay = document.querySelector('[data-filters-overlay]');
  var facets = document.querySelector('[data-facets]');

  function openFacets() {
    if (facets) facets.classList.add('is-open');
    if (filtersOverlay) filtersOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFacets() {
    if (facets) facets.classList.remove('is-open');
    if (filtersOverlay) filtersOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (filtersToggle) filtersToggle.addEventListener('click', openFacets);
  if (filtersClose) filtersClose.addEventListener('click', closeFacets);
  if (filtersOverlay) filtersOverlay.addEventListener('click', closeFacets);

  /* ============================================
     FILTRES ACTIFS — soumission automatique
     ============================================ */
  var facetsForm = document.querySelector('[data-facets-form]');
  if (facetsForm) {
    var checkboxes = facetsForm.querySelectorAll('[data-facet-checkbox]');
    checkboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit();
      });
    });

    var sortSelect = facetsForm.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit();
      });
    }
  }

  /* ============================================
     RETOUR VISUEL "AJOUTÉ AU PANIER"
     ============================================ */
  var addForm = document.querySelector('#ProductForm');
  if (addForm) {
    addForm.addEventListener('submit', function () {
      var btn = addForm.querySelector('button[type="submit"]');
      if (btn && !btn.disabled) {
        btn.classList.add('is-added');
        var original = btn.textContent;
        setTimeout(function () {
          btn.textContent = 'Ajouté ✓';
        }, 250);
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-added');
        }, 1800);
      }
    });
  }
});
/* =========================================================
   VINQO — MISE À JOUR AUTOMATIQUE DU PANIER
   Met à jour le panier dès qu'une quantité est modifiée.
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  const cartForms = document.querySelectorAll('form[action="/cart"], form[action$="/cart"]');

  cartForms.forEach(function (form) {
    let updateTimer;

    function updateCartAutomatically() {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {
        const updateButton = form.querySelector(
          'button[name="update"], input[name="update"], .cart__update-button, .cart-update-button'
        );

        if (updateButton) {
          updateButton.click();
        } else {
          form.submit();
        }
      }, 350);
    }

    form.querySelectorAll('input[name^="updates"]').forEach(function (quantityInput) {
      quantityInput.addEventListener('change', updateCartAutomatically);

      quantityInput.addEventListener('input', function () {
        if (quantityInput.value !== '') {
          updateCartAutomatically();
        }
      });
    });
  });
});
